var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconSpeed = function SvgIconSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.992 11.429c-.217 5.69-4.759 10.273-10.432 10.556C4.917 22.315-.318 17.081.015 10.44.299 4.767 4.881.226 10.571.01c6.49-.25 11.668 4.928 11.42 11.42Zm-11.05-9.473-.296.007a9.043 9.043 0 0 0-8.678 8.575c-.275 5.485 4.008 9.767 9.494 9.494a9.042 9.042 0 0 0 8.575-8.678c.2-5.255-3.883-9.44-9.094-9.398Zm3.107 3.707a.43.43 0 0 1 .43.42v.01L12.91 9.698c-.01.026.006.054.034.054h3.218c.16 0 .707.251.179.909l-.1.116-.492.532-1.126 1.177-5.097 5.24a.546.546 0 0 1-.17.144c-.132.063-.279.037-.279-.144l.009-.064.042-.209.435-1.847.765-3.11a.038.038 0 0 0-.037-.048H6.81a.43.43 0 0 1-.422-.347l-.007-.082 1.718-5.928c.066-.23.193-.43.43-.43h5.52Z",
    fill: "#2E2D37"
  })));
};

export default SvgIconSpeed;